import BpkText, {
  TEXT_COLORS,
} from '@skyscanner-internal/backpack-web/bpk-component-text';

import STYLES from './MainText.module.scss';

type MainTextProps = {
  descriptionString?: string;
  subtitleString: string;
  titleString: string;
};

const MainText = ({
  descriptionString = '',
  subtitleString,
  titleString,
}: MainTextProps) => (
  <div className={STYLES.MainText__container}>
    <BpkText
      color={TEXT_COLORS.textOnDark}
      className={STYLES['MainText__text--title']}
    >
      {titleString}
    </BpkText>
    <BpkText
      color={TEXT_COLORS.textOnDark}
      className={STYLES['MainText__text--subtitle']}
    >
      {subtitleString}
    </BpkText>
    <BpkText color={TEXT_COLORS.textOnDark}>{descriptionString}</BpkText>
  </div>
);

export default MainText;
